import React, { useState, useMemo } from 'react';
import css from './FilterSidebar.module.css';
import { FieldConfigKey } from '../../../util/enums';
import { createFilterOptions } from '../../../util/genericHelpers';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';
import classNames from 'classnames';

const GenderFilterSection = ({
  paramKey,
  handleClearFilter,
  handleCheckboxChange,
  userFields,
  selectedValues = [],
  isTalentOfferingFilters,
  isBlackBgFilter,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const genderKeyConfig = userFields.find(f => f.key === FieldConfigKey.GENDER) || {};
  const genderFilterOptions = createFilterOptions(genderKeyConfig.enumOptions) || [];

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  const filteredOptions = useMemo(() => {
    const term = searchTerm.toLowerCase();
    return genderFilterOptions.filter(opt => opt.label.toLowerCase().includes(term));
  }, [searchTerm, genderFilterOptions]);

  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <FilterSectionHeader
          isBlackBgFilter={isBlackBgFilter}
          titleId="FilterCategories.gender"
          handleClear={handleClear}
        />
      )}

      <SearchInput
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        placeholder="Search Gender..."
      />

      <div className={css.scrollable}>
        {filteredOptions.map(opt => {
          const isChecked = selectedValues.includes(opt.value);
          return (
            <label key={opt.value} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={opt.value}
                checked={isChecked}
                onChange={e => handleCheckboxChange(e, paramKey)}
              />
              <span>{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default GenderFilterSection;
